/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {DashboardTileMap} from "../model/dashboard-tile-map";
import {ResetDashboardTilesToDefaultRequest} from "../model/reset-dashboard-tiles-to-default-request";
import {SaveDashboardTilesRequest} from "../model/save-dashboard-tiles-request";
import {SuccessResponse} from "../model/success-response";
import {WebClientType} from "../model/web-client-type";

@Injectable({
    providedIn: "root",
})
export class SimDashboardTileService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public getDashboardTiles() {
        return super.get<DashboardTileMap>(`/api/DashboardTile/GetDashboardTiles`, );
    }

    public getSpecificDashboardTiles(clientType: WebClientType, roleId: string) {
        return super.get<DashboardTileMap>(`/api/DashboardTile/GetSpecificDashboardTiles`, {clientType: clientType, roleId: roleId});
    }

    public resetDashboardTilesToDefault(resetRequest: ResetDashboardTilesToDefaultRequest) {
        return super.post<SuccessResponse>(`/api/DashboardTile/ResetDashboardTilesToDefault`, resetRequest);
    }

    public saveDashboardTiles(saveRequest: SaveDashboardTilesRequest) {
        return super.post<SuccessResponse>(`/api/DashboardTile/SaveDashboardTiles`, saveRequest);
    }
}